import { render, staticRenderFns } from "./AddCustomPayment.vue?vue&type=template&id=5b00eccb&scoped=true&"
import script from "./AddCustomPayment.vue?vue&type=script&lang=js&"
export * from "./AddCustomPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00eccb",
  null
  
)

export default component.exports